export default function createZeroPrice(currency) {
  return {
    value: 0,
    short: '0',
    trimmed: '0',
    full: '0',
    currency,
  };
}
